export default function Testimonials() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            Trusted by 10,000+ Buyers
          </h2>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="rounded-2xl bg-background-50 border border-background-200/70 p-8 md:p-10">
            <div className="flex items-center gap-1.5 mb-6">
              <span className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold whitespace-nowrap">
                <i className="ri-star-fill w-3.5 h-3.5 flex items-center justify-center text-amber-500"></i>
                4.9/5.0
              </span>
            </div>

            <blockquote className="font-heading text-lg md:text-xl text-foreground-800 leading-relaxed italic">
              &ldquo;The itaobuy spreadsheet system completely changed how I source products. Instead of spending hours browsing Taobao, I can quickly compare prices and make informed decisions. The transparency is unmatched.&rdquo;
            </blockquote>

            <div className="mt-6 flex items-center gap-3">
              <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20smiling%20man%20in%20his%20early%20thirties%20with%20warm%20friendly%20expression%2C%20soft%20neutral%20cream%20background%2C%20gentle%20natural%20studio%20lighting%2C%20clean%20editorial%20portrait%20photography%2C%20casual%20business%20attire%2C%20warm%20approachable%20atmosphere%2C%20sharp%20focus%20on%20face%2C%20no%20visible%20text%2C%20genuine%20and%20trustworthy%20expression&width=80&height=80&seq=avatar-marcus-v2m&orientation=squarish"
                  alt="Itaobuy spreadsheet user testimonial"
                  title="Itaobuy Spreadsheet User Review"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-950">Marcus L.</p>
                <p className="text-xs text-foreground-500">Fashion Retailer, London</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}